import * as React from 'react';
import { Link } from 'react-router-dom';
import { Panel, ListGroup, Alert } from 'react-bootstrap';
import { IOrder, IOrderRow } from '../Entities';
import { Translate } from '../../../shared/LanguageService';
import * as Site from '../../../shared/Site';
import ProductPicturesRow from './ProductPicturesRow';
import UploadedOrderRow from './UploadedOrderRow';

interface IOrderRowProps {
    order: IOrder;
    upload: boolean;
    user:any;
    updateTotalBytes: (bytes: number) => void;
    updateProgress: (bytes: number, fileName: string, orderRowId: number, type: number) => void;
    addFileToMetadataList: (orderRowId: number, category: number, fileName: string) => void;
    removeFileFromMetadataList: (orderRowId: number, category: number, fileName: string) => void;
    toggleDragging: (dragging: boolean) => void;
    setOrderRowIdUploadDone: (orderRowId: number) => void;
    completedOrderRows: number[];
    onUploadDone: (anyUploads: boolean) => void;
    processedOrderRows?: number[];
    setOrderRowIdAllFilesProcessed?: (orderRowId: number) => void;
    uploadedOrderRowIds: number[];
}

const shouldUploadRow = (orderRow: IOrderRow, uploadedOrderRowIds: number[]) => {
    return uploadedOrderRowIds.includes(orderRow.id);
};

const OrderRow = (props: IOrderRowProps) => {
    let allOrderRowsCompleted = false;
    let allFilesProcessed = false;

    if (props.order.orderRows) {
        allOrderRowsCompleted = props.order.orderRows.every((x) =>
            props.completedOrderRows.some((y) => y === x.id)
        );

        allFilesProcessed = props.order.orderRows.every((x) =>
            props.processedOrderRows.some((y) => y === x.id)
        );
    }

    return (
        <Panel
            defaultExpanded
            className={'agent-firm-selection-panel ' + Site.getOrderCssClass(props.order.site)}
        >
            <Panel.Heading>
                <Panel.Title>{getHeader(props.order)}</Panel.Title>
            </Panel.Heading>
            <Panel.Body>
                {!allOrderRowsCompleted && props.order.photographerInformationFromFirm && (
                    <Alert bsStyle="warning">
                        <strong>
                            {Translate('photographer-uploads/page/information-from-firm')}:
                        </strong>{' '}
                        {props.order.photographerInformationFromFirm}
                    </Alert>
                )}
                {!allOrderRowsCompleted && props.order.photographerInformationFromChain && (
                    <Alert bsStyle="warning">
                        <strong>
                            {Translate('photographer-uploads/page/information-from-chain')}:
                        </strong>{' '}
                        {props.order.photographerInformationFromChain}
                    </Alert>
                )}
                {!allOrderRowsCompleted && props.order.photographerInformationFromOrder && (
                    <Alert bsStyle="warning">
                        <strong>
                            {Translate('photographer-uploads/page/information-from-order')}:
                        </strong>{' '}
                        {props.order.photographerInformationFromOrder}
                    </Alert>
                )}
                <ListGroup fill>
                    {props.order.orderRows &&
                        props.order.orderRows.map((orderRow: IOrderRow) => {
                            if (allOrderRowsCompleted && allFilesProcessed) {
                                return <UploadedOrderRow key={orderRow.id} order={props.order} />;
                            } else {
                                return (
                                    <ProductPicturesRow
                                        updateProgress={props.updateProgress}
                                        updateTotalBytes={props.updateTotalBytes}
                                        upload={shouldUploadRow(
                                            orderRow,
                                            props.uploadedOrderRowIds
                                        )}
                                        orderRow={orderRow}
                                        key={orderRow.id}
                                        orderId={props.order.id}
                                        addFileToMetadataList={props.addFileToMetadataList}
                                        removeFileFromMetadataList={
                                            props.removeFileFromMetadataList
                                        }
                                        toggleDragging={props.toggleDragging}
                                        setOrderRowIdUploadDone={props.setOrderRowIdUploadDone}
                                        orderRowProductProperties={orderRow.productProperties}
                                        setOrderRowIdAllFilesProcessed={
                                            props.setOrderRowIdAllFilesProcessed
                                        }
                                        onUploadDone={props.onUploadDone}
                                        user={props.user}
                                    />
                                );
                            }
                        })}
                </ListGroup>
            </Panel.Body>
        </Panel>
    );
};

function getHeader(order: IOrder) {
    return (
        <span>
            <span>
                &nbsp; {order.address}, {order.postalNumber}, {order.city}
            </span>
            <span className="pull-right">
                <Link style={{ display: 'initial' }} to={`/orders/${order.id}/image`}>
                    {order.orderNumber}
                </Link>
            </span>
        </span>
    );
}

export default OrderRow;
